import CurveSvg from "@components/WebsiteRevamp/Heros/HomeHeroAnimated/CurveSvg"
import React, {forwardRef} from "react"

import styles from "./CurveSection2.module.scss"

interface CurveSection2Props {
	children: React.ReactNode
	childrenOutOfBox?: React.ReactNode
	className?: string
	style?: React.CSSProperties
}

const CurveSection2 = forwardRef<HTMLDivElement, CurveSection2Props>(
	({children, className = "", style, childrenOutOfBox}, ref) => {
		return (
			<div
				className={`${styles.mainBackground} ${className}`}
				style={style}
			>
				<div className={styles.contentBox}>{children}</div>
				<div>{childrenOutOfBox}</div>

				<div
					className={styles.svgCurleBackground}
					style={{
						position: "relative",
						height: "105%",
						top: "0px",
					}}
				>
					<div
						className={styles.beforeBottomWhite}
						style={{
							padding: 0,
						}}
					>
						<CurveSvg />
					</div>
				</div>
			</div>
		)
	},
)

export default CurveSection2
